// @core/api/endpoints/workflow/verify_signed_decision.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VerifySignedDecisionRequest,
  VerifySignedDecisionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Verify signed decision
 * Recomputes the record's signature and reports whether it still matches, which is what makes the trail tamper-evident rather than merely append-only.
 */
export async function VerifySignedDecision(
  signed_decision_id: string,
  data: VerifySignedDecisionRequest,
  options?: RequestOptions
): Promise<VerifySignedDecisionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/signed-decisions/:signed_decision_id/verify`;
  requestPath = requestPath.replace(':signed_decision_id', encodeURIComponent(signed_decision_id));
  const requestOptions = options;
  return client.post<VerifySignedDecisionResponse>(requestPath, data, requestOptions);
}
